import React, { useEffect, useState } from "react";

import { BranchTariffDto } from "services/organizationBranches/restModels";
import { UpdateBranchTariffRequestDto } from "services/organizationBranches/restRequests";
import { dateToInputValue, inputValueToDate } from "shared/lib/dateInput";
import { MINOR_UNITS_IN_MAJOR } from "shared/lib/price";
import { Button } from "shared/ui/Button";
import { DateField } from "shared/ui/DateField";
import { LabeledField } from "shared/ui/LabeledField";
import { Select } from "shared/ui/Select";
import { useTariffOptions } from "shared/hooks/useTariffOptions";

import { Actions, Form } from "../../styles";

interface TariffTabProps {
    tariff: BranchTariffDto;
    saving: boolean;
    onSave: (tariff: UpdateBranchTariffRequestDto) => void;
}

export const TariffTab = ({ tariff, saving, onSave }: TariffTabProps) => {
    const { options, loading } = useTariffOptions();
    const [type, setType] = useState(tariff.type);
    const [nextPaymentDate, setNextPaymentDate] = useState("");
    const [menusActiveTillDate, setMenusActiveTillDate] = useState("");

    // Форма перезаполняется после сохранения: ответ ручки — источник правды, в том числе для
    // дат, которые бэк доводит до полудня UTC.
    useEffect(() => {
        setType(tariff.type);
        setNextPaymentDate(dateToInputValue(new Date(tariff.nextPaymentDate)));
        setMenusActiveTillDate(dateToInputValue(new Date(tariff.menusActiveTillDate)));
    }, [tariff]);

    const handleSubmit = () => {
        const nextPayment = inputValueToDate(nextPaymentDate);
        const menusActiveTill = inputValueToDate(menusActiveTillDate);

        if (!nextPayment || !menusActiveTill) return;

        onSave({
            type,
            nextPaymentDate: nextPayment.getTime(),
            menusActiveTillDate: menusActiveTill.getTime(),
        });
    };

    const canSubmit = Boolean(inputValueToDate(nextPaymentDate) && inputValueToDate(menusActiveTillDate));

    const tariffOptions = options.map((option) => ({
        value: option.type,
        label: `${option.title} (${option.monthlyPrice / MINOR_UNITS_IN_MAJOR} ${option.currencyId} в месяц)`,
    }));

    return (
        <Form>
            <LabeledField label="Тариф">
                <Select
                    value={type}
                    options={tariffOptions}
                    onChange={setType}
                    disabled={saving || loading}
                />
            </LabeledField>

            <LabeledField label="Дата следующей оплаты" htmlFor="nextPaymentDate">
                <DateField
                    id="nextPaymentDate"
                    value={nextPaymentDate}
                    onChange={setNextPaymentDate}
                    disabled={saving}
                />
            </LabeledField>

            <LabeledField
                label="Меню работает до"
                htmlFor="menusActiveTillDate"
                hint="Не раньше даты следующей оплаты"
            >
                <DateField
                    id="menusActiveTillDate"
                    value={menusActiveTillDate}
                    onChange={setMenusActiveTillDate}
                    min={nextPaymentDate}
                    disabled={saving}
                />
            </LabeledField>

            <Actions>
                <Button onClick={handleSubmit} disabled={saving || !canSubmit}>
                    Сохранить
                </Button>
            </Actions>
        </Form>
    );
};
